/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import GraphemeSplitter from 'grapheme-splitter';
import anime from 'animejs';
import { css } from '@emotion/core';
import Typewriter from 'typewriter-effect';
import {
  Responsive, Grid, Segment, Divider,
} from 'semantic-ui-react';
import LayoutContactMe from '../components/layout/layout-contact-me';
import styles from '../css/home.css';

import background from '../images/finalFinal.png';
import Test from './test';
import Segmenter from '../js/main'; // NEEDED FOR IMPORT
import five from '../../static/five-five.png';
import map from '../../static/century-tree.png';

const Home = ({
  data: {
    site: {
      siteMetadata: {
        siteName,
        homePage: {
          availableToHire, dotColors, h1Text, h2Text, typewriter,
        },
      },
    },
  },
}) => {
  const dotAnimation = useRef();
  function stringSplitter(string) {
    const splitter = new GraphemeSplitter();
    return splitter.splitGraphemes(string);
  }

  useEffect(() => {
    (function () {
      const width = 40;
      const height = 40;
      let options = {
        pieces: 4,
        animation: {
          duration: 1500,
          easing: 'easeInOutExpo',
          delay: 100,
          translateZ: 100,
        },
        parallax: true,
        positions: [
          {
            top: 0,
            left: 0,
            width,
            height,
          },
          {
            top: 55,
            left: 0,
            width,
            height,
          },
          {
            top: 0,
            left: 55,
            width,
            height,
          },
          {
            top: 55,
            left: 55,
            width,
            height,
          },
        ],
      };
      const showOptions = !!Math.round(Math.random());
      if (!showOptions) options = {};
      if (!window.Segmenter) return;
      const segmenter = new window.Segmenter(
        document.querySelector('.segmenter'),
        {
          ...options,
          onReady() {
            segmenter.animate();
          },
        },
      );
    }());
  });

  const dotCss = css`
    width: 8px;
    height: 8px;
    border-radius: 4px;
    z-index: 2;
    display: inline-block;
    margin-right: 10px;
    background: ${dotColors[0]};
  `;

  useEffect(() => {
    const dotEl = dotAnimation.current;
    availableToHire
      && anime({
        targets: dotEl,
        endDelay: 800,
        easing: 'easeInOutQuad',
        direction: 'alternate',
        background: dotColors[1],
        loop: true,
      });

    return () => availableToHire && anime.remove(dotEl);
  });

  return (
    <LayoutContactMe bgClassName="home">
      <Test />
      <Helmet>
        <title>{siteName}</title>
        <meta charset="UTF-8" />
      </Helmet>
      <Segment stackable>
        <Grid stackable style={{ overflow: 'hidden' }}>
          <Grid.Row stretched>
            <Grid.Column width={13}>
              <div className="box a">
                <div className="cloud-wrapper">
                  <div className="cloud">
                    <div className="cloud-part" />
                  </div>
                  <div className="cloud">
                    <div className="cloud-part" />
                  </div>
                  <div className="cloud">
                    <div className="cloud-part" />
                  </div>
                </div>
                <div
                  className="segmenter"
                  style={{
                    backgroundImage: `url(${background})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'auto',
                  }}
                />
              </div>
            </Grid.Column>
            <Grid.Column width={3} stackable style={{ height: '100vh' }}>
              <div className="box b" style={{}}>
                <div css={styles.dataContainer}>
                  <div css={styles.dataContent}>
                    <h1>{h1Text}</h1>
                    <h2 css={css.subParagraph}>{h2Text}</h2>
                    <Typewriter
                      css={styles.typewriter}
                      options={{
                        strings: typewriter,
                        autoStart: true,
                        loop: true,
                        delay: 55,
                        stringSplitter,
                      }}
                    />
                  </div>
                </div>
                <Responsive minWidth={992}>
                  {/* <Segment basic textAlign="center">
                    <div style={{ position: 'relative', textAlign: 'center' }}>
                      <div css={styles.dataTopbar}>
                        {availableToHire && (
                        <>
                          <div css={dotCss} ref={dotAnimation} />
                          <h5
                            style={{
                              display: 'inline',
                              color: 'white',
                              fontSize: '1.4rem',
                            }}
                          >
                            Available to be hired
                          </h5>
                        </>
                        )}
                      </div>
                    </div>
                  </Segment> */}
                  <Divider />
                </Responsive>
                <div
                  style={{
                    width: '100%',
                    background: '#35495E',
                    position: 'absolute',
                    bottom: 0,
                  }}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </LayoutContactMe>
  );
};

Home.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        siteName: PropTypes.string.isRequired,
        homePage: PropTypes.shape({
          availableToHire: PropTypes.bool.isRequired,
          h1Text: PropTypes.string.isRequired,
          h2Text: PropTypes.string.isRequired,
          typewriter: PropTypes.array.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }),
};

export default Home;

export const query = graphql`
  {
    site {
      siteMetadata {
        siteName
        homePage {
          availableToHire
          dotColors
          h1Text
          h2Text
          typewriter
        }
      }
    }
  }
`;
